import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { LOCALSTORAGE_SIDEBAR_COLLAPSE_SETTING } from "../../common/constants";
import { MobileDetectHelper } from "../../utils/mobile-detect-helper";

@Component({
  template: require("./template.html")
})
export default class ExpandSidebarComponent extends Vue {
  @Prop({ default: () => true })
  showCollapse: boolean;
  @Prop({ default: true })
  collapse: boolean;
  @Prop({ default: () => "global" })
  for: string;
  @Prop({ default: () => 1 })
  collapseCol: number;
  @Prop({ default: () => 4 })
  unCollapseCol: number;
  @Prop({default: false})
  alwayShowSideBar: boolean;

  isCollapsed: boolean;
  isMobile: boolean;
  SidebarCol: number;
  ContentCol: number;

  constructor() {
    super();
    if (this.showCollapse) {
      this.isCollapsed = this.collapse;
      let savedCollapseSetting =
        JSON.parse(
          localStorage.getItem(LOCALSTORAGE_SIDEBAR_COLLAPSE_SETTING)
        ) || {};

      if (savedCollapseSetting[this.for] === undefined) {
        savedCollapseSetting[this.for] = this.isCollapsed;
        localStorage.setItem(
          LOCALSTORAGE_SIDEBAR_COLLAPSE_SETTING,
          JSON.stringify(savedCollapseSetting)
        );
      } else {
        this.isCollapsed = savedCollapseSetting[this.for];
      }
    } else {
      this.isCollapsed = this.collapse;
    }
    
    this.ContentCol = 24;
    this.SidebarCol = 0;
    this.isMobile = false;
  }

  mounted() {
    this.isMobile = MobileDetectHelper.isTablet();
    
    window.addEventListener("resize", this.resizeHandle, false);

    this.calculateCollapse();
  }

  resizeHandle() {
    this.isMobile =  MobileDetectHelper.isTablet();

    this.calculateCollapse();
  }

  calculateCollapse(){
    if(this.alwayShowSideBar)
    {
      this.isCollapsed = false;
      this.SidebarCol = this.unCollapseCol;
      this.ContentCol = 24 - this.SidebarCol;
      
      return;
    }

    if (this.isMobile) {
      this.ContentCol = 24;
      this.SidebarCol = 0;
    } else {
      if (this.isCollapsed) {
        this.SidebarCol = this.collapseCol;
      } else {
        this.SidebarCol = this.unCollapseCol;
      }

      this.ContentCol = 24 - this.SidebarCol;
    }
  }

  handleToggle() {
    this.isCollapsed = !this.isCollapsed;
    //#output change event
    this.$emit("change", this.isCollapsed);

    //#save setting to local storage
    let savedCollapseSetting =
      JSON.parse(localStorage.getItem(LOCALSTORAGE_SIDEBAR_COLLAPSE_SETTING)) ||
      {};
    savedCollapseSetting[this.for] = this.isCollapsed;
    localStorage.setItem(
      LOCALSTORAGE_SIDEBAR_COLLAPSE_SETTING,
      JSON.stringify(savedCollapseSetting)
    );

    if (this.isCollapsed) {
      this.SidebarCol = this.collapseCol;
    } else {
      this.SidebarCol = this.unCollapseCol;
    }

    this.ContentCol = 24 - this.SidebarCol;
  }

  beforeDestroy() {
    this.isCollapsed = null;
    this.SidebarCol = null;
    this.ContentCol = null;

    window.removeEventListener("resize", this.resizeHandle, false);
  }
}
